import { Mutation, Action, VuexModule, getModule, Module } from 'vuex-module-decorators';
import store from '@/store';
import { IMasterEditionKey, IMasterEdition } from '../dto/MasterEdition';
import { supervisingModule } from '../../../store/modules/OperationSupervising';
import { KanriConstants } from '@/Kanri/fixed/KanriConstants';

/**
 * 2023.07.04 [2023F-02] add
 */
@Module({ dynamic: true, store, name: 'masterEdition', namespaced: true })
class MasterEdition extends VuexModule implements IMasterEdition {
    // state
    /**
     * @state
     * 組織情報
     */
    masterEditionKey: IMasterEditionKey = {
        traderType: '',
        nendo: '',
    };

    /**
     * @state
     * フォームデータ
     * 検索条件を格納する
     */
    formCondition: any = [];

    // getter
    /**
     * @Getter
     * パスの取得
     */
    get GET_PATH() {
        return `/${this.masterEditionKey.traderType}/${this.masterEditionKey.nendo}`;
    }

    /**
     * @Getter
     * 登録処理用パスの取得
     */
    get GET_REGIST_PATH() {
        if (supervisingModule.CHECK_MODE_UPDATE) {
            return KanriConstants.EDITION_PATH + '/update' + this.GET_PATH;
        } else {
            return KanriConstants.EDITION_PATH + '/create';
        }
    }

    /**
     * @Getter
     * 排他パスの取得
     */
    get GET_EXCLUSIVE_PATH() {
        return `/exclusive` + this.GET_PATH;
    }

    /**
     * @Getter
     * 排他パスの取得
     */
    get GET_EXCLUSIVE_DELETE_PATH() {
        return `/exclusive/delete` + this.GET_PATH;
    }

    /**
     * @Getter
     * formDataの取得
     */
    get GET_FORM_CONDITION() {
        return this.formCondition;
    }

    /**
     * @Getter
     * formDataの設定の有無
     */
    get GET_IS_FORM_CONDITION_SETTING() {
        if (this.formCondition.length === 0) {
            return false;
        } else {
            return true;
        }
    }
    /**
     * @Getter
     * keyの設定の有無
     */
    get GET_IS_MASTER_EDITION_KEY_SETTING() {
        if (this.masterEditionKey.nendo === '' && this.masterEditionKey.traderType === '') {
            return false;
        } else {
            return true;
        }
    }
    // action
    /**
     * @Action
     * 申請受付期間（キー）の保管
     * @param param (IMasterEditionKey)
     */
    @Action({})
    public setMasterEdition(param: IMasterEditionKey) {
        this.SET_EDITION(param);
    }

    /**
     * @Action
     * フォームデータの保管
     * @param data
     */
    @Action({})
    public setFormCondition(data: any) {
        this.SET_FORM_CONDITION(data);
    }

    /**
     * @Action
     * モジュールリセット
     */
    @Action({})
    public moduleReset() {
        this.MODULE_RESET();
    }

    /**
     * @Action
     * モジュール選択情報リセット
     */
    @Action({})
    public moduleSelectReset() {
        this.MODULE_EDITION_RESET();
    }

    // mutation
    /**
     * @Mutation
     * 申請受付期間（キー）の保管
     * @param param (IMasterEditionKey)
     */
    @Mutation
    private SET_EDITION(param: IMasterEditionKey) {
        this.masterEditionKey = param;
    }

    /**
     * @Mutation
     * @param data
     */
    @Mutation
    private SET_FORM_CONDITION(data: any) {
        this.formCondition = data;
    }

    /**
     * @Mutation
     */
    @Mutation
    private MODULE_RESET() {
        this.masterEditionKey = {
            traderType: '',
            nendo: '',
        };
        this.formCondition = [];
    }

    /**
     * @Mutation
     */
    @Mutation
    private MODULE_EDITION_RESET() {
        this.masterEditionKey = {
            traderType: '',
            nendo: '',
        };
    }

}

export const masterEditionModule = getModule(MasterEdition);
